export class AccAddNotesParameterDto {
    note: string;
    communityId: number;
    customerId: string;
    accItemId: number;
    clearCache: boolean;
}
